import { ReporteRutas,MenuRutas, GetHeaderRequest, GetResponseBody,GetResponseBodyFetch } from './RutasConfig.jsx';
import axios from 'axios';

export const Get_Description_Report_Request = async (pToken,  pReport) => {
    const data ={pReport}
    const result = await axios.post(MenuRutas.Get_Description_Report,JSON.stringify(data),{headers: GetHeaderRequest(pToken)});
    return await  GetResponseBody(result);
}

export const SetParametrosReporte_Request = async (pToken, pParametros) => {    
    const result = await fetch(ReporteRutas.SetParametrosReporte, {
        method: 'POST',
        headers: GetHeaderRequest(pToken),
        body: JSON.stringify(pParametros)
    });
    return GetResponseBodyFetch(result);
};

// export const SetParametrosReporte_Request = async (pToken,  pParametros) => {
//     const data ={pParametros}
//     const result = await axios.post(ReporteRutas.SetParametrosReporte,JSON.stringify(data),{headers: GetHeaderRequest(pToken)});
//     return await GetResponseBody(result);
// }